<div class="login-container m-auto">
  <div class="card boxshadow">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Helpful Contacts Maintenance</h5>
      <button *ngIf="!isFormVisible" class="btn btn-success btn-sm" (click)="openForm()">
        <i class="fas fa-plus"></i> Add Contact
      </button>
    </div>
    <div class="card-body">

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ errorMessage }}
        <button type="button" class="close" (click)="errorMessage = ''" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Success Message -->
      <div *ngIf="successMessage" class="alert alert-success alert-dismissible fade show" role="alert">
        {{ successMessage }}
        <button type="button" class="close" (click)="successMessage = ''" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Add/Edit Form -->
      <div *ngIf="isFormVisible" class="card mb-4 border-primary">
        <div class="card-header bg-light">
          <h6 class="mb-0">{{ isEditMode ? 'Edit Contact' : 'Add New Contact' }}</h6>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label for="category">Category <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="category"
                   [(ngModel)]="form.category" placeholder="e.g., BACKGROUND CHECK INQUIRIES">
          </div>
          <div class="form-group">
            <label for="contactName">Contact Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="contactName"
                   [(ngModel)]="form.contactName" placeholder="e.g., Annie Palmer or N/A">
          </div>
          <div class="form-group">
            <label for="email">Email <span class="text-danger">*</span></label>
            <input type="email" class="form-control" id="email"
                   [(ngModel)]="form.email" placeholder="e.g., apalmer@thesmartcircle.com">
          </div>
          <div class="form-group">
            <button class="btn btn-primary" (click)="saveContact()" [disabled]="isLoading">
              <i class="fas fa-save"></i> {{ isLoading ? 'Saving...' : 'Save' }}
            </button>
            <button class="btn btn-secondary ml-2" (click)="closeForm()" [disabled]="isLoading">
              <i class="fas fa-times"></i> Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- Contacts Table -->
      <div *ngIf="!isFormVisible" class="table-responsive">
        <div *ngIf="isLoading" class="text-center py-4">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <table *ngIf="!isLoading" class="table table-bordered table-striped table-hover">
          <thead class="table-light">
            <tr>
              <th>Category</th>
              <th>Contact Name</th>
              <th>Email</th>
              <th style="width: 150px;">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="contacts.length === 0">
              <td colspan="4" class="text-center py-4">No contacts found</td>
            </tr>
            <tr *ngFor="let contact of contacts">
              <td>{{ contact.category }}</td>
              <td>{{ contact.contactName }}</td>
              <td>
                <a href="mailto:{{ contact.email }}">{{ contact.email }}</a>
              </td>
              <td>
                <button class="btn btn-sm btn-warning" (click)="editContact(contact)" title="Edit">
                  <i class="fas fa-edit"></i>
                </button>
                <button class="btn btn-sm btn-danger ml-1" (click)="deleteContact(contact.id)" title="Delete">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
